import React, { Component } from "react";
import { Button } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import {
  GetProductDetails,
  GetCategoryDetails,
  GetUserLogin,
  GetWishListDetails,
} from "../../../services";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { addToCart } from "../../../../store/actions/cartActions";
import { NotificationManager } from "react-notifications";
import { encryptId } from "../../../../utils/crypto";
import CircularProgress from "@material-ui/core/CircularProgress";

class Category extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      currentcategoryname: null,
      categorybyproduct: [],
      subcategories: [],
      isloaded: false,
      toggle: false,
      wishlist: [], // State for wishlist items
      custId: null, // Initialize custId state

      itemsPerPage: 18,
      visibleCount: 18,
      subcategoryId: null, // Added subcategoryId to state
      isMobileView: window.innerWidth <= 786,
      openQuickView: false,
      selectedProduct: null,
      selectedVariants: [],
      totalMoney: 0,
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);

    // Get categoryId, subcategoryId, and page from URL parameters
    const queryParams = new URLSearchParams(this.props.location.search);
    const categoryId = queryParams.get("categoryId") || 130;
    const subcategoryId = queryParams.get("subcategoryId");
    const page = parseInt(queryParams.get("page"), 10) || 1;

    await this.fetchSubCategories();

    if (subcategoryId) {
      this.setState({ subcategoryId }); // Set subcategoryId in state
      this.handleFilterCategory({ id: subcategoryId }, page);
    } else {
      this.fetchProductsByCategory(categoryId, page);
    }
    this.fetchCategoryName(subcategoryId);
    const email = sessionStorage.getItem("email");
    if (email) {
      let user = await GetUserLogin.getCustomerDetail(email);
      if (user) {
        this.setState({ custId: user.data.id });
      }
    }
    window.addEventListener("resize", this.handleResize);
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if category or subcategory has changed
    const { categoryId, subcategoryId } = this.state;
    if (
      prevState.subcategoryId !== subcategoryId ||
      prevState.categoryId !== categoryId
    ) {
      this.fetchCategoryName(subcategoryId || categoryId); // Update the category name
    }
  }

  componentWillUnmount() {
    // Remove resize listener when component is unmounted
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    // Check if the screen width is <= 786px and update the state
    this.setState({ isMobileView: window.innerWidth <= 786 });
  };

  async fetchCategoryName(subcategoryId) {
    const { subcategories } = this.state;
   const category = subcategories.find(
  (cat) => Number(cat.id) === Number(subcategoryId)
);
    if (category) {
      this.setState({ currentcategoryname: category.name });
    }
  }

  async fetchSubCategories() {
    try {
      const subcategories =
        await GetCategoryDetails.getAllCategorySubCategoryList();
      if (subcategories) {
        // Remove duplicates and sort the subcategories alphabetically by name
        const uniqueSubcategories = subcategories.data
          .filter(
            (subcategory, index, self) =>
              index === self.findIndex((s) => s.name === subcategory.name),
          )
          .sort((a, b) => a.name.localeCompare(b.name));

this.setState(
  {
    subcategories: uniqueSubcategories,
    isloaded: true,
  },
  () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const subcategoryId = queryParams.get("subcategoryId");

    if (subcategoryId) {
      this.fetchCategoryName(Number(subcategoryId));
    }
  }
);
      } else {
        NotificationManager.error("Failed to fetch subcategories.");
      }
    } catch (error) {
      NotificationManager.error("Error fetching subcategories.");
    }
  }

  async fetchProductsByCategory(categoryId, page = 1) {
    try {
      const products = await GetProductDetails.getProductByCategory(categoryId);
      if (products) {
        this.setState({
          list: products.data,
          categorybyproduct: products.data,
          isloaded: true,
          currentPage: page,
        });
        await this.fetchCategoryName(categoryId);
      } else {
        NotificationManager.error("No products found for this category.");
        this.setState({ isloaded: true });
      }
    } catch (error) {
      NotificationManager.error("Error fetching products by category.");
      this.setState({ isloaded: true });
    }
  }

  handleFilterCategory = async (subcategory, page = 1) => {
    const subcategoryId = subcategory.id;
    this.setState({
      categorybyproduct: [],
      isloaded: false,
      toggle: true,
      visibleCount: 18,
      subcategoryId, // Update subcategoryId in state
    });
    await this.fetchCategoryName(subcategoryId);
    // Update URL with subcategoryId and page as parameters
    this.props.history.push(`?subcategoryId=${subcategoryId}&page=${page}`);

    try {
      const products =
        await GetProductDetails.getProductByCategory(subcategoryId);
      if (products) {
        this.setState({
          categorybyproduct: products.data,
          isloaded: true,
          visibleCount: 18,
          // pageGroupStart: 1,
        });
        const element = document.getElementById("collapseOne");
        if (element && element.classList.contains("show")) {
          element.classList.remove("show");
        }
        window.scrollTo(0, 0);
      } else {
        NotificationManager.error("Empty data in category", "Undefined");
      }
    } catch (error) {
      NotificationManager.error("Error fetching products by category.");
      this.setState({ isloaded: true });
    }
  };

  toggleWishlist = (productId) => {
    const { wishlist } = this.state;
    const isProductInWishlist = wishlist.includes(productId);

    if (isProductInWishlist) {
      this.setState({ wishlist: wishlist.filter((id) => id !== productId) });
    } else {
      this.setState({ wishlist: [...wishlist, productId] });
    }
  };

  handleQuickView = async (productId) => {
    try {
      const response = await GetProductDetails.getProductById(productId);

      if (response && response.success) {
        this.setState({
          selectedProduct: response.data,
          openQuickView: true,
          selectedVariants: [],
          totalMoney: 0,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  closeQuickView = () => {
    this.setState({
      openQuickView: false,
      selectedProduct: null,
    });
  };

  handleVariantSelect = (variant) => {
    this.setState((prev) => {
      const exists = prev.selectedVariants.find(
        (item) => item.id === variant.id,
      );

      let updated;

      if (exists) {
        updated = prev.selectedVariants.filter(
          (item) => item.id !== variant.id,
        );
      } else {
        updated = [...prev.selectedVariants, variant];
      }

      const totalMoney = updated.reduce(
        (sum, item) => sum + item.variantPrice,
        0,
      );

      return {
        selectedVariants: updated,
        totalMoney,
      };
    });
  };

  handleQuickAddToCart = () => {
    const { selectedProduct, selectedVariants } = this.state;

    if (selectedVariants.length === 0) {
      NotificationManager.error("Please select at least one machine variant.");
      return;
    }

    this.props.addToCart(selectedProduct, selectedVariants);

    this.closeQuickView();
  };

  handleAddToWishlistClick = async (productId) => {
    const { custId } = this.state;

    if (!custId) {
      NotificationManager.error("Please log in to add items to your wishlist.");
      return;
    }

    const data = { custId: custId, productId: productId };

    try {
      let result = await GetWishListDetails.addWishlistItem(data); // Call service function
      if (result) {
        NotificationManager.success("Added to wishlist!");
        this.toggleWishlist(productId); // Toggle wishlist after adding
      } else {
        NotificationManager.error("Product is already in your wishlist.");
      }
    } catch (error) {
      NotificationManager.error(
        "An error occurred while adding to the wishlist.",
      );
    }
  };

  handleGoBack = () => {
    window.history.back(); // Go back to the previous page
  };

  handleProductShare = (productId) => {
    const shareUrl = `https://jc-creations.co.in/p/${productId}`;
    if (navigator.share) {
      navigator
        .share({
          title: "Check out this product!",
          url: shareUrl,
        })
        .then(() => console.log("Share successful"))
        .catch((error) => console.log("Sharing failed", error));
    } else {
      alert("Copy this URL: " + shareUrl);
    }
  };

  handleShare = (categoryId) => {
    const shareUrl = `https://jc-creations.co.in/product/catalogsearch/result?categoryId=${categoryId}`;
    if (navigator.share) {
      navigator
        .share({
          title: "Check out this category!",
          url: shareUrl,
        })
        .then(() => console.log("Share successful"))
        .catch((error) => console.log("Sharing failed", error));
    } else {
      alert("Copy this URL: " + shareUrl);
    }
  };


  handleDownloadPDF = async () => {
    const { currentcategoryname } = this.state;
    // Show notification that download is starting
    NotificationManager.info("Download started...", "Downloading PDF");

    try {
      // Call the service to download the PDF by passing the category name
      await GetProductDetails.downloadCategoryPDF(currentcategoryname);

      // Show notification when download is completed
      NotificationManager.success(
        "Download completed successfully!",
        "PDF Download",
      );
    } catch (error) {
      // Handle error in case of failure
      NotificationManager.error("An error occurred while downloading the PDF.");
    }
  };
   handleShowMore = () => {
      this.setState((prevState) => ({
        visibleCount: prevState.visibleCount + prevState.itemsPerPage,
      }));
    };



  render() {
    const {
      list,
      subcategories,
      categorybyproduct,
      currentcategoryname,
      toggle,
      isloaded,
      wishlist,
      currentPage,
      itemsPerPage,
      visiblePages,
      pageGroupStart,
      isMobileView,
    } = this.state;

    // Calculate the number of visible pages based on screen size
    const maxVisiblePages = visiblePages;

    const currentProducts = categorybyproduct.slice(
      0,
      this.state.visibleCount
    );

 
    return (
      <div>
        <section className="pt-3 pb-3 page-info section-padding border-bottom bg-white single-product-header-bk">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-8 col-md-6 d-flex align-items-center">
                <a href="#">
                  <strong>
                    <span className="mdi mdi-home" /> <a href="/">Home </a>
                  </strong>
                </a>{" "}
                <span className="mdi mdi-chevron-right" />{" "}
                <a href="#">Categories</a>
              </div>
              <div className="col-4 col-md-3 text-md-end d-flex justify-content-end">
                <Button
                  variant="contained"
                  className="back-btn goback"
                  onClick={this.handleGoBack}
                >
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    style={{ marginRight: "5px" }}
                  />{" "}
                  Back
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="shop-list section-padding">
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <div className="shop-filters">
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header" id="headingOne">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link"
                            data-toggle={isMobileView ? "collapse" : ""}
                            data-target={isMobileView ? "#collapseOne" : ""}
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            All Category{" "}
                            <span className="mdi mdi-chevron-down float-right" />
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseOne"
                        className={
                          isMobileView ? "collapse show" : "show" // Collapse only in mobile view
                        }
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="card-body card-shop-filters">
                          {isloaded
                            ? subcategories.map((subcategory, index) => (
                              <div className="card-body" key={index}>
                                <div className="list-group">
                                  <span
                                    className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                                    onClick={() =>
                                      this.handleFilterCategory(subcategory)
                                    }
                                    style={{ cursor: "default" }}
                                  >
                                    {subcategory.name}
                                    <div>
                                      <i
                                        className="mdi mdi-share-variant"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.handleShare(subcategory.id);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                        }}
                                        title="Share this category"
                                      />
                                    </div>
                                  </span>
                                </div>
                              </div>
                            ))
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-9">
                <div className="shop-head d-flex justify-content-between align-items-center">
                  <h5 className="mb-3">Category products</h5>

                  <Button
                    variant="contained"
                    onClick={this.handleDownloadPDF}
                    style={{
                      background: "linear-gradient(135deg, #ff9800, #ff6f00)",
                      color: "#fff",
                      fontWeight: "600",
                      fontSize: window.innerWidth <= 768 ? "12px" : "15px",
                      textTransform: "none",
                      borderRadius: "20px",
                      padding:
                        window.innerWidth <= 768 ? "6px 12px" : "10px 22px",
                      boxShadow: "0 6px 16px rgba(255, 152, 0, 0.35)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <i
                      className="mdi mdi-download"
                      style={{
                        marginRight: "5px",
                        fontSize: window.innerWidth <= 768 ? "14px" : "20px",
                      }}
                    ></i>
                    {currentcategoryname} PDF
                  </Button>
                </div>

                {!isloaded ? (
                  <div className="progress-bar-bk">
                    <CircularProgress color="secondary" />
                    <div>Loading products...</div> {/* Loading message */}
                  </div>
                ) : toggle ? (
                  <div className="row no-gutters">
                    {currentProducts.length ? (
                      currentProducts.map((row, index) => (
                        <div key={index} className="col-md-4">
                          <div className="item">
                            <div
                              className="product"
                              style={{ backgroundColor: "black" }}
                            >
                              <Link
                                to={{
                                  pathname: `/p/${encryptId(row.id)}`,
                                  state: row,
                                }}
                              >
                                <div className="product-header">
                                  <img
                                    loading="lazy" // Lazy load images
                                    crossOrigin="anonymous"
                                    className="img-fluid"
                                    src={row.photo}
                                    alt={row.name}
                                    width="100%"
                                    height="auto"
                                    style={{ objectFit: "contain" }}
                                  />
                                  <div className="product-actions">
                                    {/* Wishlist */}
                                    <i
                                      className={`mdi ${wishlist.includes(row.id)
                                        ? "mdi-heart"
                                        : "mdi-heart-outline"
                                        }`}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.handleAddToWishlistClick(row.id);
                                      }}
                                    />

                                    <i
                                      className="mdi mdi-eye-outline"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.handleQuickView(row.id);
                                      }}
                                    />
                                  </div>
                                </div>
                              </Link>
                              <div className="product-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary btn-sm float-right"
                                  onClick={() =>
                                    this.handleProductShare(row.id)
                                  }
                                >
                                  <i className="mdi mdi-share" /> Share
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-danger">
                        No products found in this category.
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="row no-gutters">
                    {list.length ? (
                      list.map((row, index) => (
                        <div key={index} className="col-md-4">
                          <div className="item">
                            <div
                              className="product"
                              style={{ backgroundColor: "black" }}
                            >
                              <Link
                                to={{
                                  pathname: `/p/${encryptId(row.id)}`,
                                  state: row,
                                }}
                              >
                                <div className="product-header">
                                  <img
                                    loading="lazy" // Lazy load images
                                    crossOrigin="anonymous"
                                    className="img-fluid"
                                    src={row.photo}
                                    alt={row.name}
                                    width="100%"
                                    height="auto"
                                    style={{ objectFit: "contain" }}
                                  />
                                  <div className="product-actions">
                                    {/* Wishlist */}
                                    <i
                                      className={`mdi ${wishlist.includes(row.id)
                                        ? "mdi-heart"
                                        : "mdi-heart-outline"
                                        }`}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.handleAddToWishlistClick(row.id);
                                      }}
                                    />

                                    <i
                                      className="mdi mdi-eye-outline"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.handleQuickView(row.id);
                                      }}
                                    />
                                  </div>
                                </div>
                              </Link>
                              <div className="product-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary btn-sm float-right"
                                  onClick={() =>
                                    this.handleProductShare(row.id)
                                  }
                                >
                                  <i className="mdi mdi-share" /> Share
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-danger">No products found.</div>
                    )}
                  </div>
                )}
                {currentProducts.length < categorybyproduct.length && (
                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "30px",
                      marginBottom: "20px",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleShowMore}
                      style={{
                        padding: "10px 35px",
                        borderRadius: "30px",
                        textTransform: "none",
                        fontWeight: 600,
                        backgroundColor: "#e96125"
                      }}
                    >
                      Show More
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        {this.state.openQuickView && this.state.selectedProduct && (
          <div className="quick-view-overlay">
            <div className="quick-view-modal">
              <button className="close-btn" onClick={this.closeQuickView}>
                ×
              </button>

              <div className="row">
                <div className="col-12 col-lg-4">
                  <img
                    src={this.state.selectedProduct.photo}
                    alt=""
                    className="quick-product-image"
                  />
                </div>

                <div className="col-12 col-lg-4">
                  <h2 className="quick-product-title">
                    {this.state.selectedProduct.name}
                  </h2>

                  <div className="quick-detail-card">
                    <h5>🧵 Stitch Details</h5>
                    <p>{this.state.selectedProduct.stitches}</p>
                  </div>

                  <div className="quick-detail-card">
                    <h5>📏 Dimensions</h5>
                    <p>{this.state.selectedProduct.height}</p>
                  </div>

                  <div className="quick-detail-card">
                    <h5>📝 Description</h5>
                    <p>{this.state.selectedProduct.sortDesc}</p>
                  </div>
                </div>

                <div className="col-12 col-lg-4">
                  <div className="variant-header">
                    <h4>Select Machine</h4>
                    <h3>₹{this.state.totalMoney}</h3>
                  </div>

                  {this.state.selectedProduct.productvariants
                    ?.slice()
                    .sort((a, b) => a.variantName.localeCompare(b.variantName))
                    .map((variant) => {
                      const selected = this.state.selectedVariants.some(
                        (item) => item.id === variant.id,
                      );

                      return (
                        <div
                          key={variant.id}
                          className={`variant-card ${selected ? "active" : ""}`}
                          onClick={() => this.handleVariantSelect(variant)}
                        >
                          <div>
                            <strong>{variant.variantName}</strong>
                          </div>

                          <div>₹{variant.variantPrice}</div>
                        </div>
                      );
                    })}
                </div>
              </div>

              <div className="quick-footer">
                <button
                  className="wishlist-btn-modern"
                  onClick={() =>
                    this.handleAddToWishlistClick(this.state.selectedProduct.id)
                  }
                >
                  <i className="mdi mdi-heart-outline" />
                  Wishlist
                </button>

                <button
                  className="cart-btn-modern"
                  onClick={this.handleQuickAddToCart}
                >
                  <i className="mdi mdi-cart" />
                  Add To Cart
                  {this.state.totalMoney > 0 && ` • ₹${this.state.totalMoney}`}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  addToCart: (product, selectedVariants) =>
    dispatch(addToCart(product, selectedVariants)),
});

export default connect(null, mapDispatchToProps)(Category);
